module.exports = __webpack_public_path__ + "static/media/anc14ru.e4224e3c.pdf";